export const compose = styles => {
    let style = {};
    for (let index in styles) {
        style = { ...style, ...styles[index] }
    }
    return style;
};

// text

export const muted = {
    fontSize: '11px',
    color: 'rgb(170, 170, 170)',
};

export const preserveWhitespace = {
    whiteSpace: 'pre',
};

// card

export const cardHeader = {
    marginBottom: '0.5rem',
    fontSize: '25px',
    fontWeight: 300,
};

export const cardSubheader = {
    fontSize: '14px',
    marginBottom: '1.5rem',
};